import { TranslateHelper } from '@app/_helpers';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';
interface Features {
    icon?,
    header?,
    body?
}
interface FeaturesOptions {
    layout?: 'classic' | 'boxed',
    features?: Features[]
}
@Component({
    selector: 'app-block-features',
    templateUrl: './block-features.component.html',
    styleUrls: ['./block-features.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, NgFor, MatIconModule]
})


export class BlockFeaturesComponent implements OnInit {
    @Input() options: FeaturesOptions;

    constructor(public translateHelper: TranslateHelper) {
    }

    ngOnInit(): void {
    }
}
